module.exports = __webpack_public_path__ + "static/media/banner.5e813dd6.png";